import React from 'react';
import BadgeBase, { TBadge } from './BadgeBase';
import { BadgeSignals } from '../../types/TEBadgeSignal';

const Warning = (props: Omit<TBadge, 'signal'>) => <BadgeBase {...props} signal={BadgeSignals.Warning} />;

export default Warning;
